import styled from 'styled-components';

export const StyledListItem = styled.li`
  & + & {
    margin-top: 4rem;
  }
`;

StyledListItem.displayName = 'StyledListItem';
